import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ProfileCard').create(({ theme }) => ({
  root: {
    display: 'flex',
    width: '100%',
    padding: '16px',
    flexDirection: 'column',
    position: 'relative',
    zIndex: 30,
    gap: '16px',
    borderRadius: '10px',
    border: '1px solid',
    borderColor: theme.colors.borders.secondary,
    background: theme.colors.button.secondary.background,
  },

  nicknameAndPfpWrapper: {
    display: 'flex',
    height: '80px',
    gap: '16px',
    alignItems: 'center',
  },

  rewardWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center',
  },

  nicknameAndIdWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
  },

  username: {
    color: theme.colors.text.primary,
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: theme.sizes.texts.lineHeight.m,
  },

  id: {
    color: theme.colors.text.sub,
    fontSize: theme.sizes.texts.fontSize.s,
    fontWeight: 500,
    lineHeight: theme.sizes.texts.lineHeight.m,
    cursor: 'pointer',
  },

  rewardsText: {
    color: theme.colors.text.secondary,
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: '350',
    lineHeight: '14px',
  },

  rewardsValueWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    gap: '4px',
  },

  valueText: {
    color: theme.colors.text.primary,
    fontFamily: 'Space Grotesk',
    fontSize: '32px',
    fontWeight: '540',
    lineHeight: '35px',
    textTransform: 'uppercase',
  },

  balancesWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  balance: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    gap: '8px',
    p: {
      margin: 0,
      color: theme.colors.text.secondary,
    },
  },

  shareButton: {
    height: '52px',
    fontSize: theme.sizes.texts.fontSize.m,
    gap: '6px',
  },
}))
